export const ChatVentanaStyles =
/*
import { makeStyles, createStyles } from '@material-ui/core/styles';
export const ChatVentanaStyles = makeStyles(() =>
  createStyles(*/
{
    'root': {
        borderRadius: '20px',
        width: '100%',
        height: '90%',
        paddingBottom:'0px'
    },
    'disminuida': {
        marginRight: 360,
        flex: 1,
        marginLeft: 1
    },
    'aumentada': {
        marginRight: '2%',
        flex: 1,
    },
    'input-container':{
        float: "right" as 'right',
        width: '30%',
        height: '100%'
    },
    'input-busqueda':{
        borderRadius: '50px',
        width: '100%',
        outline: 'none',
        height: '100%',
        border: '1px solid #C5C5C5',
        "&:focus": {
            outline:'none',
            outlineWidth: '0',
            boxShadow: 'none'
        },
        boxShadow: '4px 5px 5px 0px rgba(213,213,214,1)'
    },
    'header': {
        paddingTop:'8px',
        paddingBottom:'8px',
        borderBottom:'1px solid #E0E0E0'
    },

    'footer': {
        paddingTop: '2px',
        paddingBottom: '2px',
        borderTop:'1px solid #E0E0E0'
    },

    'pos': {
        marginBottom: '12'
    },
    'hide': {
        display: 'none'
    },
    'barraTitulo': {
        display: 'flex',
        alignContent:'flex-start',
        justifyContent:'flex-end',
        padding:'10px'
    },
    'pad': {
        paddingTop: '0%',
    },
    'padding':{
        paddingTop: '0px',
    },
    'scrolleable': {
        display: 'block',
        overflowY: 'auto' as 'auto',
        height: '480px',
        scrollBehavior: 'smooth' as 'smooth',
    
    },


}